<template>
  <div class="page-container payment-codes-list">
    <div class="page-title-container">
      <h1 class="page-title">Códigos de pago</h1>
    </div>
    <div class="table-container">
      <div class="table-header">
        <div class="d-flex d-lg-none justify-content-end mb-2">
          <button
            type="button"
            class="button-tooltip d-lg-none"
            v-b-tooltip.hover
            title="Recargar"
            @click="loadData()"
          >
            <RefreshTableIcon />
          </button>

          <b-button
            :to="{ name: 'config-payment-codes-create' }"
            variant="none"
            class="button button-primary"
            >Agregar</b-button
          >
        </div>

        <div
          class="d-flex flex-column flex-md-row justify-content-between align-items-start"
        >
          <section class="w-100 d-flex justify-content-end align-items-center">
            <button
              type="button"
              class="button-tooltip d-none d-lg-block"
              v-b-tooltip.hover
              title="Recargar"
              @click="loadData()"
            >
              <RefreshTableIcon />
            </button>

            <SearchBar
              placeholder="Buscar por código de pago, nombres o correos electrónicos"
              @search="onSearch"
              @input="search = $event"
              class="w-100 w-lg-auto"
            />

            <div class="d-none d-lg-block">
              <b-button
                :to="{ name: 'config-payment-codes-create' }"
                variant="none"
                class="button button-primary ml-lg-2"
                >Agregar</b-button
              >
            </div>
          </section>
        </div>
      </div>
      <div class="mb-0">
        <!-- Mobile -->
        <table class="custom-table position-relative w-100 d-xl-none">
          <thead>
            <tr>
              <th class="text-left px-4">
                Código de pago
                <span class="d-inline-block ml-3">Nombres</span>
              </th>
            </tr>
          </thead>
          <tbody v-if="list.length">
            <tr v-for="o in list" :key="o.id">
              <td class="px-4">
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <p class="my-0 d-flex">
                      <span>{{ o.code }}</span>
                      <span class="d-inline-block ml-3" v-html="o.names"></span>
                    </p>

                    <div class="table-mobile-options mt-2">
                      <router-link
                        class="mr-2"
                        :to="{
                          name: 'config-payment-codes-details',
                          params: { id: o.id },
                        }"
                      >
                        Ver datos
                      </router-link>
                      <router-link
                        :to="{
                          name: 'config-payment-codes-edit',
                          params: { id: o.id },
                        }"
                        class="mr-2"
                      >
                        Editar
                      </router-link>
                      <a
                        href="#"
                        class="text-danger"
                        @click="openDelete(o)"
                      >
                        Eliminar
                      </a>
                    </div>
                  </div>

                  <button
                    type="button"
                    class="border-0 bg-transparent"
                    @click="o.showMobileData = !o.showMobileData"
                  >
                    <span v-if="!o.showMobileData">
                      <i class="ri-arrow-down-s-line"></i>
                    </span>
                    <span v-else>
                      <i class="ri-arrow-up-s-line"></i>
                    </span>
                  </button>
                </div>

                <div class="pt-3" v-if="o.showMobileData">
                  <ul class="list-unstyled p-0">
                    <li class="d-flex flex-column align-items-start mb-2">
                      <span class="font-weight-bold">Documentos:</span>
                      <span class="d-inline-block mt-1" v-html="o.documents"></span>
                    </li>
                    <li class="d-flex flex-column align-items-start mb-2">
                      <span class="font-weight-bold">Teléfonos:</span>
                      <span class="d-inline-block mt-1" v-html="o.phones"></span>
                    </li>
                    <li class="d-flex flex-column align-items-start mb-2">
                      <span class="font-weight-bold"
                        >Correos electrónicos:</span
                      >
                      <span class="d-inline-block mt-1" v-html="o.emails"></span>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>

          <p class="empty-table-text text-center" v-else>
            No se encontraron registros.
          </p>
        </table>

        <!-- Desktop -->
        <table class="custom-table w-100 position-relative d-none d-xl-table">
          <thead>
            <tr>
              <th>Código de pago</th>
              <th>Nombres</th>
              <th>Documentos</th>
              <th>Teléfonos</th>
              <th>Correos electrónicos</th>
              <th class="pr-md-4">Opciones</th>
            </tr>
          </thead>
          <tbody v-if="list.length">
            <tr v-for="o in list" :key="o.id">
              <td class="text-center">
                {{ o.code }}
              </td>
              <td>
                <span class="name-list" v-html="o.names"></span>
              </td>
              <td class="text-center">
                <span class="d-inline-block" v-html="o.documents"></span>
              </td>
              <td class="text-center">
                <span class="d-inline-block" v-html="o.phones"></span>
              </td>
              <td>
                <span class="emails-list d-inline-block" v-html="o.emails"></span>
              </td>

              <td class="text-center d_option pr-md-4">
                <DropdownTable>
                  <template slot="dropdown-content">
                    <DropdownItem
                      :to="{
                        name: 'config-payment-codes-details',
                        params: { id: o.id },
                      }"
                      text="Ver datos"
                    />
                    <DropdownItem
                      :to="{
                        name: 'config-payment-codes-edit',
                        params: { id: o.id },
                      }"
                      text="Editar"
                    />
                    <DropdownItem text="Eliminar" @click="openDelete(o)" />
                  </template>
                </DropdownTable>
              </td>
            </tr>
          </tbody>

          <p class="empty-table-text text-center" v-else>
            No se encontraron registros.
          </p>
        </table>
      </div>
      <div
        class="table-footer d-flex justify-content-end align-items-center"
        v-if="list.length"
      >
        <pagination
          :total="total"
          :page="page"
          :page-size="pageSize"
          :pages="pages"
          :changePage="changePage"
          :changePageSize="changePageSize"
        />
      </div>
    </div>
    <ConfirmationModal
      :show="confirmationModal.show"
      @hide="closeConfirmationModal"
      :data="confirmationModal"
      @confirm="confirmModal"
    />
  </div>
</template>

<script>
import {
  Alert,
  ConfirmationModalMixin,
  PaginationMixin,
  FilterMixin,
  DropdownTable,
  DropdownItem,
  SearchBar,
  ConfirmationModal,
  RefreshTableIcon,
} from "wize-admin";

import { PaymentCodeService } from "@/core/services";

export default {
  components: {
    SearchBar,
    ConfirmationModal,
    DropdownTable,
    DropdownItem,
    RefreshTableIcon,
  },
  mixins: [PaginationMixin, ConfirmationModalMixin, FilterMixin],
  data() {
    return {
      list: [],
      selectedOption: null,
    };
  },
  methods: {
    setLineBreak(value) {
      if (!value) {
        return null;
      }
      let list = value.split('|')

      if(list.length > 2) {
        list[1] = `${list[1]}...`
      }

      list = list.slice(0, 2)

      return list.join('| <br />')
    },
    async loadData() {
      try {
        await this.$store.dispatch("app/loading", true);
        const params = {
          page: this.page - 1,
          size: this.pageSize,
          search: this.search,
          ...this.filters,
        };
        const response = await PaymentCodeService.list(params);
        this.list = response.payload.content.map((item) => {
          return {
            ...item,
            names: item.names ? this.setLineBreak(item.names) : '-',
            documents: item.documents ? this.setLineBreak(item.documents) : '-',
            phones: item.phones ? this.setLineBreak(item.phones) : '-',
            emails: item.emails ? this.setLineBreak(item.emails) : '-',
            showMobileData: false,
          };
        });

        this.total = response.payload.totalElements;
        this.pages = response.payload.totalPages;
      } catch (error) {
        console.error(error);
        Alert.error(error);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    confirmModal() {
      this.closeConfirmationModal();
      if (this.confirmationModal.action === "delete") this.deleteItem();
    },
    openDelete(o) {
      this.selectedOption = o;
      this.openConfirmationModal({ acceptText: "Borrar", action: "delete" });
    },
    async deleteItem() {
      try {
        await this.$store.dispatch("app/loading", true);
        await PaymentCodeService.delete(this.selectedOption.id);
        await this.loadData();
        Alert.success("Código de pago eliminado");
      } catch (ex) {
        console.error(ex);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
  },
  async mounted() {
    await this.loadData();
  },
};
</script>

<style lang="stylus" scoped>
@import "../Styles/payment-codes-list.styl"
</style>
